import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'

const SWIPE_THRESHOLD = 10

const LineSwipable = (props) => {
  const { currentLineName, target, children } = props
  const navigate = useNavigate()
  const startXRef = useRef(null)
  const startYRef = useRef(null)

  useEffect(() => {
    const getTouches = (evt) => {
      return evt.touches ||             // browser API
             evt.originalEvent.touches  // jQuery
    }

    const handleTouchStart = (evt) => {
      startXRef.current = getTouches(evt)[0].clientX
      startYRef.current = getTouches(evt)[0].clientY
    }

    const handleTouchMove = (evt) => {
      if (!startXRef.current || !startYRef.current) {
        return
      }

      const xDiff = startXRef.current - evt.touches[0].clientX
      const yDiff = startYRef.current - evt.touches[0].clientY

      if (Math.abs( xDiff ) > Math.abs( yDiff )) {/*most significant*/
        if ( SWIPE_THRESHOLD < xDiff ) {
          /* left swipe */
          gotoRightLine()
        } else if ( xDiff < -SWIPE_THRESHOLD ) {
          /* right swipe */
          gotoLeftLine()
        }
      }
      /* reset values */
      startXRef.current = null
      startYRef.current = null
    }

    document.addEventListener('touchstart', handleTouchStart, false)
    document.addEventListener('touchmove', handleTouchMove, false)

    return () => {
      document.removeEventListener('touchstart', handleTouchStart, false)
      document.removeEventListener('touchmove', handleTouchMove, false)
    }
  })

  const gotoRightLine = () => {
    if (currentLineName === 'for_jre') {
       navigate(`/lines/for_tokyu/${target}`)
    } else if (currentLineName === 'for_tokyu') {
      navigate(`/lines/main/${target}`)
    } else if (currentLineName === 'main') {
      navigate(`/lines/izumino/${target}`)
  }
}

  const gotoLeftLine = () => {
    if (currentLineName === 'for_tokyu') {
      if (target === 'trains') {
        navigate(`/lines/for_jre/trains#28`)
      }
    } else if (currentLineName === 'main') {
      navigate(`/lines/for_tokyu/${target}`)
    } else if (currentLineName === 'izumino') {
      navigate(`/lines/main/${target}`)
    }
  }

  return children
}

LineSwipable.propTypes = {
  currentLineName: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
}

export default LineSwipable
